import { cloneDeep } from 'lodash';

function _nullToUndefined(obj: { [key: string]: any }) {
  for (const k in obj) {
    if (obj[k] === null) {
      delete obj[k];
    } else if (typeof obj === 'object') {
      _nullToUndefined(obj[k]);
    }
  }

  return obj;
}

export default function nullToUndefined(obj: Object) {
  return _nullToUndefined(cloneDeep(obj));
}
